import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { cdnImage } from '@/utils/image-utils';
import { useAbsoluteNavigate } from '@/hooks/useAbsoluteNavigate';
import { Button } from '@/components/buttons/Button';
import { ChevronLeftIcon } from '@heroicons/react/20/solid';
import Card from '@/components/shared/card/Card';
import { useSelector } from 'react-redux';
import { selectIsAuthenticated } from '@/store/selectors/authSelectors';
import useAuthentication from '@/hooks/useAuthentication';
import { OpenedFrom } from '@/lib/gTagManager';

function PromotionError() {
  const intl = useIntl();
  const navigate = useAbsoluteNavigate();
  const isAuthenticated = useSelector(selectIsAuthenticated);
  const { openAuthentication, isReturningUser } = useAuthentication();

  const onClickHandler = () => {
    if (!isAuthenticated) {
      openAuthentication(OpenedFrom.PromotionPage);
      return;
    }

    navigate('/promotions');
  };

  const ctaTextId = isAuthenticated
    ? 'promotions.all'
    : isReturningUser
    ? 'login.login'
    : 'header.register';

  const promotionErrorDescriptionId = isAuthenticated
    ? 'promotion.error'
    : isReturningUser
    ? 'promotion.login'
    : 'promotion.register';

  return (
    <div>
      <div className="max-w-5xl mx-auto px-4 pt-4 pb-16">
        <button
          type="button"
          className="flex items-center py-4 mb-4"
          onClick={() => navigate('/promotions')}
        >
          <ChevronLeftIcon className="w-6 h-6" />
          {intl.formatMessage({ id: 'promotions.all' })}
        </button>
        <Card>
          <div className="text-center">
            <img
              src={cdnImage('sitting-cat.png', {
                width: '200',
                height: '200',
                fit: 'scale-down',
              })}
              alt="Lucky Cat Sitting"
              className="mx-auto mb-4"
            />
            <div>
              <FormattedMessage
                id={promotionErrorDescriptionId}
                values={{
                  a: str => (
                    <span
                      onClick={() => navigate('/promotions')}
                      className="text-blue-light font-bold underline cursor-pointer"
                    >
                      {str}
                    </span>
                  ),
                }}
              />
            </div>
            <Button
              onClickHandler={onClickHandler}
              text={intl.formatMessage({ id: ctaTextId })}
              className="!w-fit px-8 mt-4"
            />
          </div>
        </Card>
      </div>
      <div className="text-center my-16"></div>
    </div>
  );
}

export default PromotionError;
